module.exports = __webpack_public_path__ + "static/media/frontend_logo_with_name.318f1741.webp";